import React from "react";
import { SHOP } from "@/constants/testIds";
import { optimizeImg } from "@/lib/img";

export default function CategoryGrid({ categories = [], onSelect }) {
  if (!categories.length) return null;
  return (
    <section
      data-testid={SHOP.categorySection}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 sm:mt-14"
    >
      <div className="flex items-end justify-between mb-5 sm:mb-7">
        <div>
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#0056D2] font-bold">
            Shop by category
          </div>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mt-1 tracking-tight">
            Everything Electrical, Under One Roof
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3 sm:gap-5">
        {categories.map((c) => (
          <button
            key={c.id}
            data-testid={SHOP.categoryTile(c.slug)}
            onClick={() => onSelect?.(c)}
            className="group flex flex-col items-center gap-2 sm:gap-3 p-2 rounded-xl hover:bg-gray-50 transition-colors"
          >
            <div className="relative w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded-full overflow-hidden border border-gray-200 bg-gray-100 shadow-sm group-hover:shadow-md group-hover:border-[#0056D2] transition-all">
              <img
                src={optimizeImg(c.image, 200)}
                alt={c.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
                decoding="async"
              />
            </div>
            <span className="text-[11px] sm:text-xs lg:text-sm font-semibold text-gray-800 text-center leading-tight line-clamp-2">
              {c.name}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
